// extracted by mini-css-extract-plugin
export default {"Box":"repo-picker-module__Box--O_nLO","Text":"repo-picker-module__Text--wfOXh","Text_1":"repo-picker-module__Text_1--XJZUz"};